import { z } from 'zod';
export const clarificationEpisodeDispositionSchema = z.enum([
    'open',
    'answered',
    'superseded',
    'timed_out',
    'cancelled',
    'draft_override_used',
]);
export const clarificationQuestionSchema = z
    .object({
    id: z.string().uuid(),
    prompt_markdown: z.string().min(1).max(8000),
})
    .strict();
export const clarificationEpisodeDtoSchema = z
    .object({
    id: z.string().uuid(),
    organization_id: z.string().uuid(),
    work_item_id: z.string().uuid(),
    spec_generation_attempt_id: z.string().uuid(),
    disposition: clarificationEpisodeDispositionSchema,
    superseded_by_episode_id: z.string().uuid().nullable().optional(),
    superseded_reason: z.record(z.unknown()).nullable().optional(),
    questions: z.array(clarificationQuestionSchema).min(1).max(3),
    tracker_signal_status: z
        .enum(['pending', 'sent', 'failed', 'skipped_not_tracker_backed'])
        .nullable()
        .optional(),
    created_at: z.string(),
    updated_at: z.string(),
})
    .strict();
export const specificationAttemptClarificationStatusSchema = z
    .object({
    attempt_id: z.string().uuid(),
    lifecycle_state: z.string().min(1),
    primary_blocker: z.enum([
        'none',
        'awaiting_clarification',
        'generating',
        'generation_failed',
        'policy_or_budget',
        'provider_health',
        'superseded',
    ]),
    /** Customer-safe explanation when `primary_blocker` is not `none` / `generating`. */
    blocker_detail: z.string().max(512).nullable().optional(),
    resume_state: z.string().min(1),
    resume_reason: z.string().min(1),
    clarification_episode: clarificationEpisodeDtoSchema.nullable().optional(),
    /**
     * True when the intake's generation gates skipped this attempt (no handoff was created). A
     * manual start skips those gates, so the member can still generate.
     */
    skipped_by_generation_gates: z.boolean().optional(),
})
    .strict();
export const draftAnywayRequestSchema = z
    .object({
    confirm_provisional_draft: z.literal(true),
})
    .strict();
//# sourceMappingURL=clarification-episode.schemas.js.map